var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-img",on:{"click":function($event){_vm.processClick()}}},[_c('div',{staticClass:"wrapper-img"}),_vm._v(" "),_c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.source,"srcset":_vm.source + ' 1x, ' + _vm.source2x + ' 2x',"alt":""}}),_vm._v(" "),_c('div',{staticClass:"wrapper-img"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.13.7.0@vue-loader/lib/template-compiler?{"id":"data-v-65c7fee0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.13.7.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/AutoIcon.vue
// module id = null
// module chunks = 